import type { ReactNode } from 'react';

type AccordionHeaderProps = {
  icon: ReactNode;
  iconBg: string;
  iconColor: string;
  title: string;
  description: string;
  badge?: ReactNode;
};

export const AccordionHeader = ({
  icon,
  iconBg,
  iconColor,
  title,
  description,
  badge,
}: AccordionHeaderProps) => (
  <div className="flex items-center gap-4">
    <div
      className="w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-[16px]"
      style={{ backgroundColor: iconBg, color: iconColor }}
    >
      {icon}
    </div>
    <div className="flex flex-col gap-0.5">
      <div className="flex items-center gap-3">
        <span className="text-base font-semibold leading-[1.5] text-[#131313]">
          {title}
        </span>
        {badge}
      </div>
      <span className="text-sm leading-snug text-[#646464]">{description}</span>
    </div>
  </div>
);
